<template>
  <section class="landing-office">
    <section class="office-title">
    </section>
    <div class="inner-container office-container">
      <h1 class="section-title">Escritório lindo novinho e acessível</h1>
      <p class="section-subtitle">Um escritório incrível localizado no coração da Faria Lima, localizado em um dos melhores bairros de SP,
       rodeado por bons restaurantes.</p>
       <div class="row ">
        <img class="office-image" src="../assets/images/geral.jpg"></img>
        <div class="office-section-about md-col-12 col-4">
          <h4>Open Space + HotDesking</h4>
          <p>Não temos lugar fixo. Acreditamos que um espaço aberto favorece a colaboração entre os funcionários do Moip e otimiza o uso do espaço do escritório.</p>
        </div>
        <div class="office-section-about md-col-12 col-4">
          <h4>Prezamos pela informalidade</h4>
          <p>É possível ser sério sem ser mal-humorado ou vestir um terno; é possível trabalhar muito sendo alegre; é possível falar com respeito usando gírias. Sabemos que você é um adulto ;)</p>
        </div>
        <div class="office-section-about md-col-12 col-4">
          <h4>Também gostamos de descanso e diversão</h4>
          <p>Trabalhamos sério e duro, mas é exatamente por isso que reconhecemos a importância de uma paradinha para a recarga das baterias.</p>
        </div>
      </div>
    </section>
  </section>
</template>

<style lang="less">
  @import (reference) '../assets/styles/references';
  .landing-office {
    .office-container{
      padding: 0 @md-spacer;
    }
    .inner-container{
      position: relative;
    }

    .section-title{
      margin-top: -250px;
      color: @white !important;
    }

    .section-title{
      color: @white;

      &::after{
        background: @white;
      }
    }

    .office-image{
      width: 90%;
      background-color: grey;
      display: block;
      margin: 0 auto;
    }

    .office-section-about{
      width: 30%;
      h4{
        color: @pink;
        line-height: 1.3em;
        text-transform: uppercase;;
      }
      p{
        color: @black;
      }
    }

    .section-subtitle{
      color: @white;
    }

    .office-title{
      background: linear-gradient(45deg, rgba(236, 26, 98, 0.65) 0%,
        rgba(244, 66, 93, 0.65) 59%,
        rgba(251, 105, 89, 0.65) 100%),
      url("../../static/IMG_2118.png") no-repeat;
      height: 451px;
      background-size: 100% 451px;
      border-radius: @xs-spacer/2;
      margin: @sm-spacer;

      .inner-container{
        overflow: hidden;
      }
    }
    @media @tablet{
      .section-subtitle,
      .section-title{
        width: 90%;
        padding-left: @xs-spacer/2;
      }
    }
    @media @phone{
      .section-title{
        margin-top: -300px;
      }
    }

  }
</style>

<script>
  import RoundButton from './RoundButton'

  export default {

    data() {
      return {
        repos: [],
        repos_length: '',
        showMore: false
      }
    },
    components: {
      RoundButton
    },
    computed: {
      firstSixReposByStar() {
        return this.repos.slice(0, 6);
      }
    },
    mounted: function() {
      let gitHubApi = 'https://api.github.com/orgs/moip/repos?per_page=50'
      this.$http.get(gitHubApi).then((response) => {
        this.repos = response.body
        this.repos.sort(function (a, b) {
          return b.stargazers_count - a.stargazers_count
        });
        this.repos_length = this.repos_length
      }, (errorResponse) => {
        console.log(errorResponse)
      });
    }
  }
</script>



// WEBPACK FOOTER //
// LandingOffice.vue?13db5a1e